import React from 'react';
import './BlockWeAreTrusted.scss';
import './BlockWeAreTrusted-media.scss';
import Counter from '../Counter/Counter';
import Title from '../Title/Title';
import {ICounter} from "../Counter/interfaces";

export interface Props {
  title: string;
  subtitle: string;
  items: ICounter[]
}

const BlockWeAreTrusted = ({title, subtitle, items}: Props) => {
  return (
    <div className="block-we-are-trusted">
      <Title center title={title} text={subtitle} />
      <div className="block-we-are-trusted__statistic">
        {items.map((item, i) => (
          <Counter {...item} key={i} />
        ))}
      </div>
    </div>
  );
};

export default BlockWeAreTrusted;
